import type { ChangeEvent, SyntheticEvent } from 'react';

export { Group, GroupBackground } from './group';
export { Prefix, Suffix } from './input_base';
export { Field } from './field';
export { Textarea } from './textarea';
export { Select } from './select';
export { Control } from './control';
export { DateTimePicker } from './date_time_picker';
export { ColorPicker } from './color_picker';
export { CreatePassword } from './create_password';
export { SearchableList } from './searchable_list';
export { Label } from './label';
export { InfoText } from './info_text';
export { DelayedTextInput } from './delayed_text_input';
export { RangeSlider } from './range_slider';
export { AttachmentField } from './attachment';
export { TimeZoneSelect } from './time_zone_select';
export { YearSelect } from './year_select';
export { BirthDate } from './birth_date';
export { Panel } from './panel';
export { ImageUpload } from './image_upload';

export type InputChangeEvent = (
	event:
		| SyntheticEvent
		| ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
) => void;

/**
 * Scrolls the first field with a validation error into view. Input.Group marks
 * its errored fieldset with `data-has-error`, so this works for any field type.
 * Used after validation fails so the user can see why the form didn't advance,
 * instead of the error sitting off-screen with no visible feedback.
 */
export function scrollFirstErrorIntoView(): void {
	// Defer to the next frame so the DOM has rendered the error state before we
	// measure and scroll to it.
	requestAnimationFrame(() => {
		const firstError = document.querySelector<HTMLElement>('[data-has-error]');

		if (!firstError) {
			return;
		}

		firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });

		// Move focus to the first focusable control inside the errored group for
		// keyboard and screen-reader users.
		const focusable = firstError.querySelector<HTMLElement>(
			'input, select, textarea, [tabindex]'
		);
		focusable?.focus({ preventScroll: true });
	});
}
